/**
 * Extract a YouTube video ID from various URL formats.
 *
 * Strict variant used by public-facing pages: returns an empty string
 * when no valid 11-char ID can be extracted, so callers can use the
 * truthy check to fall through to thumbnail/Coming-Soon placeholders.
 *
 * NOTE: Admin tools use a separate, looser version in
 * `/app/frontend/src/components/admin/utils.js` that returns the
 * original input on no-match. Do not unify these without auditing
 * every admin call site.
 *
 * @param {string|null|undefined} input - YouTube URL or video ID
 * @returns {string} Extracted 11-char video ID, or '' if not extractable
 */
export const extractYouTubeId = (input) => {
  if (!input || typeof input !== 'string') return '';
  const trimmed = input.trim();
  if (!trimmed) return '';
  // If it's already just an ID (11 characters, alphanumeric with - and _)
  if (/^[a-zA-Z0-9_-]{11}$/.test(trimmed)) return trimmed;
  // Try to extract from various YouTube URL formats
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})/
  ];
  for (const pattern of patterns) {
    const match = trimmed.match(pattern);
    if (match && match[1]) return match[1];
  }
  return '';
};
